jQuery(document).ready(function($){
  $(document).on('click', '.variant-radios > div', function(){
    let variantID = $(this).find('input').data('variant-id');
    $('.size_specification').removeClass('active');
    $('#'+variantID).addClass('active');
    
    let selectedSize = $(this).find('input').val().toLowerCase().replace(/\s+/g, "-");    
    $('.product-media-thumbnails-wrapper .product-thumbnail:not(.hidden)').first().click();
    // console.log(selectedSize);
    let sizeOptions = [];
    $(".product-variant-picker .variant-radios input[type='radio']").each(function() {
      sizeOptions.push($(this).val().toLowerCase().replace(/\s+/g, "-"));
    });
    $(".variant-sizes").data('sizes', sizeOptions);
    // console.log(sizeOptions);
    updateImages(selectedSize);
    
    // update Ship Message
    let ship_msg = $(this).find('input[type="radio"]').data('ship-msg');
    $(this).closest('.product-info-inner').find('.ship_msg').text(ship_msg);
  });
  
  
  function updateImages(selectedSize) {
    $(".product-page .product-gallery-wrapper .product-gallery__slide").each(function() {
      var mediaAlt = $(this).attr("class").split(" ")[1]; // Get the second class (alt-based class)

      // Show images that match selected size or general images
      if (mediaAlt === selectedSize || !$(".variant-sizes").data("sizes").includes(mediaAlt)) {
        $(this).removeClass('hidden');
      } else {
        $(this).addClass("hidden");
      }
    });
    $(".product-page .product-media-thumbnails .product-thumbnail").each(function() {
      var mediaAlt = $(this).attr("class").split(" ")[1]; // Get the second class (alt-based class)

      // Show images that match selected size or general images
      if (mediaAlt === selectedSize || !$(".variant-sizes").data("sizes").includes(mediaAlt)) {
        $(this).removeClass('hidden');
      } else {
        $(this).addClass("hidden");
      }
    });
  }

  /********************************************************
  Product media images update for PhotoSwipe modal ********
  *********************************************************/
  if($('body').hasClass('product-page')) {
    $('.product-variant-picker input[type="radio"]:checked + label').click();
    $('.product-media-thumbnails-wrapper .product-thumbnail:not(.hidden)').first().click();
  }
 
});

window.addEventListener("scroll", function() {
  document.querySelectorAll(".custom-slideshow .slide-content").forEach((el) => {
    // let speed = -0.15; // Adjust for smoothness
    // let offset = window.pageYOffset * speed;
    // el.style.backgroundPosition = `center ${offset}px`;
  });
});

document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".slideshow-element-wrapper .slide-background .image-loader img").forEach((el) => {
    el.classList.add("img-loaded");
  });

  function scrollToWithOffset(id, offset = 0) {
    const el = document.getElementById(id);
    if (!el) return;
  
    const top = el.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({
      top,
      behavior: 'smooth'
    });
  }
  
  // Use event delegation on document or a specific container
  document.addEventListener('click', function (e) {
    const link = e.target.closest('.option-link');
    if (!link) return;
  
    e.preventDefault();
  
    const targetId = link.dataset.target?.replace('#', '');
    if (targetId) {
      scrollToWithOffset(targetId, 0); // adjust offset if needed
    }
  });


  
});